import ngClipboard from 'angular-clipboard';
import ngTranslate from 'angular-translate';
import ngFileUpload from 'ng-file-upload';
import uiRouter from '@uirouter/angularjs';
import uniq from 'lodash/uniq';
import forEach from 'lodash/forEach';
import forEachRight from 'lodash/forEachRight';
import size from 'lodash/size';

import { ImageEditorModule } from 'admin/components/ImageEditor/index.ng';
import { ImagesServiceModule } from 'services/data/images.service';
import { ImageReaderServiceModule } from 'services/utilities/imageReader.service';
import { OnScrollEndDirective } from 'directives/onScrollEnd.directive';

import deleteTemplate from './imageLibraryDelete.html';

export const ImageLibraryControllerModule = angular
    .module('app.components.imageLibrary.imageLibraryController', [
        'ngMaterial',
        ngClipboard.name,
        ngTranslate,
        ngFileUpload,
        ImagesServiceModule,
        ImageEditorModule,
        ImageReaderServiceModule,
        OnScrollEndDirective,
        uiRouter
    ]).controller('ImageLibraryController', (
        $scope,
        $q,
        $window,
        $mdDialog,
        $mdBottomSheet,
        $mdToast,
        $mdMedia,
        imagesService,
        imageReader,
        $timeout,
        context,
        associationTags,
        multiSelect,
        clearImage,
        clipboard,
        $translate,
        $document,
        $state
    ) => {
        var imageLimit = 2500;
        var vm = {
            currentPage: 0,
            pageSize: 25,
            totalImagesCount: 0,
            imageLimitReached: false,
            translationsArray: [
                'IMAGELIBRARY.CLIPBOARDSUCCESS',
                'IMAGELIBRARY.DELETESUCCESS',
                'IMAGELIBRARY.IMAGE',
                'IMAGELIBRARY.IMAGES',
                'ERROR.IMAGEVALIDATION'
            ],
            translations: [],
            images: [],
            selectedImages: {},
            shouldBeFullscreen: false,

            hasTriedToGetData: false,
            noMoreResults: false,
            isLoading: false,
            isLoadingMoreResults: false,
            isImageEditModalOpen: false,

            context,
            associationTags,
            multiSelect,

            selectImage,
            deselectImage,
            toggleImageSelect,
            selectAll,
            deselectAll,
            getSelectedImage,

            deleteSelectedImages,
            showDeleteConfirmation,
            confirmDelete,
            cancelDelete,

            supportsCopy: false,
            showValidationError,
            onClipboardCopySuccess,
            useImages,
            editSelectedImage,
            noImagesToModify,
            getSelectedImagesSize,
            resetImages,
            doubleClickImage,
            cancel,

            setPreviouslyUsedTitle,
            previouslyUsedTitle: context,
            previouslyUsedImages: [],
            previouslyUsedImagesPage: 0,
            previouslyUsedImagesTotalCount: 0,
            enterPreviouslyUsedState,
            exitPreviouslyUsedState,
            previouslyUsedImagesMode: 'preview',
            maxNumberInPreview: 3,

            getImages,
            getPreviouslyUsedImages,
            getAllImages,
            previouslyUsedImagesPreview: [],
            hidePreviouslyUsedPreview,
            onScroll,
            onCloseImageEditor,

            clearImage,
            clearSelectedHeaderImage,
            $state
        };

        function init() {
            $scope.vm = vm;

            // Get Images
            getPreviouslyUsedImages().then((images) => {
                setPreviouslyUsedTitle();
                setPreviewImages(images);
            });

            $q.all([getAllImages(), imagesService.getImageLimit()]).then((response) => {
                imageLimit = response[1];
                vm.imageLimitReached = (vm.totalImagesCount >= imageLimit);
            });

            initCopyToClipboard();

            $translate(vm.translationsArray).then((translations) => {
                vm.translations = translations;
            });

            $scope.$watch(() => { return $mdMedia('gt-xs'); }, (isGreaterThanXS) => {
                vm.shouldBeFullscreen = !isGreaterThanXS;
            });

            $scope.$watch('vm.files', () => {
                if (vm.imageLimitReached) {
                    $translate('ERROR.IMAGELIMITREACHED').then((error) => {
                        $mdToast.show($mdToast.simple()
                            .textContent(error)
                            .position('bottom left')
                        );
                    });
                    return;
                }

                if (vm.files && vm.files.length > 0) {
                    vm.isLoading = true;

                    $window.dataLayer.push({ event: 'admin_image-gallery-upload' });

                    uploadImages(vm.files).then((images) => {
                        addImagesToGrid(images, true);
                        vm.isLoading = false;
                    }).catch(() => {
                        vm.isLoading = false;
                        $translate('ERROR.GENERAL_FAILURE_ERROR').then((error) => {
                            $mdToast.show($mdToast.simple()
                                .textContent(error)
                                .position('bottom left')
                            );
                        });
                    });
                }
            });

            $scope.$watch('vm.invalidFiles', (newVal) => {
                if (newVal && newVal.length > 0) vm.showValidationError();
            });
        }

        function showValidationError() {
            $mdToast.show($mdToast.simple()
                .textContent(vm.translations['ERROR.IMAGEVALIDATION'])
                .position('bottom left')
                .parent('.image-library')
                .hideDelay(4000));
        }

        function initCopyToClipboard() {
            if ($document[0].execCommand('copy', false)) vm.supportsCopy = true;
        }

        function setPreviewImages(images) {
            vm.previouslyUsedImagesPreview = images.slice(0, vm.maxNumberInPreview);
        }

        function setPreviouslyUsedTitle() {
            vm.previouslyUsedTitle =
                vm.context === 'editstore' && vm.associationTags.length > 0 ?
                    vm.associationTags[0] : vm.context;
        }

        function getImages(tags, page, count) {
            vm.isLoadingMoreResults = true;
            return imagesService.getImagesFromAlgolia(tags, page, count)
                .then((data) => {
                    vm.hasTriedToGetData = true;
                    vm.isLoadingMoreResults = false;
                    return data;
                });
        }

        function getPreviouslyUsedImages() {
            return getImages(associationTags, vm.previouslyUsedImagesPage, 20).then((data) => {
                vm.previouslyUsedImagesTotalCount = data.nbHits;
                if (data.hits.length > 0) {
                    vm.previouslyUsedImages = uniq(vm.previouslyUsedImages, el => el.id).concat(data.hits);
                }
                vm.previouslyUsedImagesPage += 1;
                return data.hits;
            });
        }

        function getAllImages() {
            if (!vm.noMoreResults) {
                return getImages([], vm.currentPage, vm.pageSize).then((data) => {
                    vm.totalImagesCount = data.nbHits;
                    if (data.hits.length > 0) vm.images = uniq(vm.images, el => el.id).concat(data.hits);
                    vm.currentPage += 1;
                    if (data.hits.length === 0 || data.page === data.nbPages - 1) vm.noMoreResults = true;
                    vm.imageLimitReached = (vm.totalImagesCount >= imageLimit);
                });
            }
            return $q.resolve();
        }

        function onScroll() {
            if (!vm.isLoadingMoreResults && !vm.noMoreResults) {
                if (vm.previouslyUsedImagesMode === 'full') {
                    vm.getPreviouslyUsedImages();
                } else {
                    vm.getAllImages();
                }
            }
        }

        function enterPreviouslyUsedState() {
            vm.resetImages();
            vm.deselectAll();
            vm.previouslyUsedImagesMode = 'full';
            vm.images = angular.copy(vm.previouslyUsedImages);
        }

        function exitPreviouslyUsedState() {
            vm.deselectAll();
            vm.previouslyUsedImagesMode = 'preview';
            vm.resetImages();
            getAllImages();
        }

        function hidePreviouslyUsedPreview() {
            vm.previouslyUsedImagesMode = 'hidden';
        }

        function addImagesToGrid(images, selectOnAdd) {
            angular.forEach(images, (image) => {
                vm.images.splice(0, 0, image);
                if (multiSelect && selectOnAdd) {
                    selectImage(0);
                }
            });
        }

        function resetImages() {
            vm.deselectAll();
            vm.noMoreResults = false;
            vm.currentPage = 0;
            vm.images = [];
        }

        function doubleClickImage(index) {
            vm.selectImage(index);
            vm.useImages();
        }

        function selectImage(index) {
            vm.images[index].selected = true;
            vm.selectedImages[vm.images[index].id] = vm.images[index];
        }

        function deselectImage(index) {
            vm.images[index].selected = false;
            delete vm.selectedImages[vm.images[index].id];
        }

        function toggleImageSelect(index) {
            if (vm.images[index].selected) {
                deselectImage(index);
            } else {
                if (!multiSelect && getSelectedImagesSize() === 1) {
                    deselectAll();
                }
                selectImage(index);
            }
        }

        function selectAll() {
            vm.selectedImages = {};
            forEach(vm.images, (image, key) => {
                selectImage(key);
            });
        }

        function deselectAll() {
            if (getSelectedImagesSize() > 0) {
                vm.selectedImages = {};
                forEach(vm.images, (image, key) => {
                    vm.images[key].selected = false;
                });
            }
        }

        function useImages() {
            if (associationTags.length > 0) {
                imagesService.updateTags(vm.selectedImages, associationTags);
            }
            let returnData = multiSelect ? vm.selectedImages : getSelectedImage();
            $mdDialog.hide(returnData);
        }

        function editSelectedImage() {
            vm.isImageEditModalOpen = true;

            const image = getSelectedImage();
            vm.selectedImage = image;
            vm.imageId = image.id;
            vm.imageUrl = image.fullUri;
            vm.onSave = uploadFile;
        }

        function uploadFile(blob) {
            vm.isLoading = true;
            vm.isImageEditModalOpen = false;
            return uploadImages([blob])
                .then((data) => {
                    $mdToast.show($mdToast.simple()
                        .textContent('Image edited successfully')
                        .position('bottom left')
                    );
                    $window.dataLayer.push({
                        event: 'admin_image-editor_image-edit-save-success'
                    });
                    deselectAll();
                    addImagesToGrid(data, true);
                })
                .finally(() => {
                    vm.isLoading = false;
                    vm.isImageEditModalOpen = false;
                });
        }

        function getSelectedImage() {
            return vm.selectedImages[Object.keys(vm.selectedImages)[0]];
        }

        function onClipboardCopySuccess() {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.translations['IMAGELIBRARY.CLIPBOARDSUCCESS'])
                    .position('bottom left')
                    .parent('.image-library')
                    .hideDelay(3000)
            );
        }

        function showDeleteSuccess(numberDeleted) {
            let deleteMessagePlurality = numberDeleted === 1 ?
                vm.translations['IMAGELIBRARY.IMAGE'] :
                vm.translations['IMAGELIBRARY.IMAGES'];

            let deleteMessage = `${numberDeleted} ${deleteMessagePlurality}
                ${vm.translations['IMAGELIBRARY.DELETESUCCESS']}`;

            $mdToast.show(
                $mdToast.simple()
                    .textContent(deleteMessage)
                    .position('bottom left')
                    .parent('.image-library')
                    .hideDelay(3000));
        }

        function showDeleteConfirmation() {
            $mdBottomSheet.show({
                template: deleteTemplate,
                parent: '.image-library',
                preserveScope: true,
                scope: $scope,
                clickOutsideToClose: false
            }).then((resolve) => {
                if (resolve !== false) { // hack to prevent image from being deleted on dialog close
                    deleteSelectedImages();
                }
            });
        }

        function cancelDelete() {
            $mdBottomSheet.cancel();
        }

        function confirmDelete() {
            $mdBottomSheet.hide();
        }

        function deleteSelectedImages() {
            vm.isLoading = true;

            imagesService.removeImages(vm.selectedImages)
                .then(() => {
                    showDeleteSuccess(getSelectedImagesSize());
                    vm.isLoading = false;

                    forEachRight(vm.images, (image, key) => {
                        if (image.selected) {
                            vm.images.splice(key, 1);
                        }
                    });

                    vm.selectedImages = {};
                })
                .catch((err) => {
                    let message = 'There was an error deleting the image';
                    if (err.data && err.data.message) message = `${message}:<p>${err.data.message}</p>`;
                    return $mdDialog.show(
                        $mdDialog.alert()
                            .title('Error')
                            .htmlContent(message)
                            .ariaLabel('Error')
                            .ok('OK')
                    );
                });
        }

        function noImagesToModify() {
            return vm.images.length === 0 || (!multiSelect && getSelectedImagesSize() === 0);
        }

        function getSelectedImagesSize() {
            return size(vm.selectedImages);
        }

        function cancel() {
            if (vm.isImageEditModalOpen) {
                onCloseImageEditor();
            }
            $mdDialog.cancel();
        }

        function onCloseImageEditor() {
            vm.isImageEditModalOpen = false;
            $scope.$apply();
        }

        function uploadImages(files) {
            return imageReader.getImagesData(files)
                .then((dataFiles) => {
                    return imagesService.saveImages(dataFiles);
                });
        }

        function clearSelectedHeaderImage() {
            if (vm.clearImage) {
                vm.clearImage();
                $mdDialog.cancel();
            }
        }

        init();
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/imageLibrary/imageLibrary.controller.js